import env from '../config/env';
import boxStateDTO from '../interfaces/dto/boxStateDTO';
import { get } from '../utils/api';
import { apiPaths } from '../utils/apiPaths';

const getBoxState = (): Promise<boxStateDTO> => {
  const url = apiPaths.getBoxState;
  return get(env.BOXSTATE_API_URL, url).then((response) => response.data);
};

export { getBoxState };
